module.exports = __webpack_public_path__ + "static/media/shanxiwenhua.7daef3d2.png";